function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
export default {
  computed: _objectSpread(_objectSpread({}, mapState({
    visible: function visible(s) {
      return s.api.resultDisplay === 'frequency';
    },
    result: function result(s) {
      return s.api.result;
    }
  })), {}, {
    elements: function elements() {
      return this.result.elements;
    },
    elements_reference: function elements_reference() {
      return this.result.elements_reference;
    },
    documents: function documents() {
      return this.result.documents;
    },
    documents_reference: function documents_reference() {
      return this.result.documents_reference;
    },
    per_million: function per_million() {
      return this.$fn(Math.round(this.elements * 1000000 / this.elements_reference));
    },
    documents_result: function documents_result() {
      return {
        documents: this.$fn(this.documents),
        documents_reference: this.$fn(this.documents_reference)
      };
    },
    emptyResult: function emptyResult() {
      return this.elements === 0;
    }
  }),
  methods: {
    showKwic: function showKwic(e) {
      this.$store.dispatch('api/navigateToResultType', 'kwic');
      this.$store.dispatch('pagination/changePage', 1);
    }
  }
};